interface IconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

const defaultIconProps: IconProps = {
  size: 24,
  color: "currentColor",
  className: ""
};

export function GameIcon({ size = 24, color = "currentColor", className = "" }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="17" cy="17" r="3" fill={color} />
      <circle cx="7" cy="17" r="3" fill={color} />
      <circle cx="12" cy="7" r="3" fill={color} />
      <path d="M12 10L7 14M12 10L17 14" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

export function ProfileIcon({ size = 24, color = "currentColor", className = "" }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="8" r="4" strokeWidth="2" />
      <path
        d="M20 21C20 16.5817 16.4183 13 12 13C7.58172 13 4 16.5817 4 21"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function StoreIcon({ size = 24, color = "currentColor", className = "" }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 6H21M3 6V14C3 18 5 20 9 20H15C19 20 21 18 21 14V6M3 6L5 3H19L21 6"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M9 11H15" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

export function HomeIcon({ size = 24, color = "currentColor", className = "" }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 10.5V21H9V14H15V21H21V10.5L12 3L3 10.5Z"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function BackIcon({ size = 24, color = "currentColor", className = "" }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 12H5M5 12L12 19M5 12L12 5"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SettingsIcon({ size = 24, color = "currentColor", className = "" }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.4 15C19.1277 15.6171 19.2583 16.3378 19.73 16.82L19.79 16.88C20.1656 17.2553 20.3765 17.7642 20.3765 18.295C20.3765 18.8258 20.1656 19.3347 19.79 19.71C19.4147 20.0856 18.9058 20.2965 18.375 20.2965C17.8442 20.2965 17.3353 20.0856 16.96 19.71L16.9 19.65C16.4178 19.1783 15.6971 19.0477 15.08 19.32C14.4755 19.5791 14.0826 20.1724 14.08 20.83V21C14.08 22.1046 13.1846 23 12.08 23C10.9754 23 10.08 22.1046 10.08 21V20.91C10.0677 20.2376 9.64778 19.6337 9.01998 19.39C8.40286 19.1177 7.68218 19.2483 7.19998 19.72L7.13998 19.78C6.76472 20.1556 6.25583 20.3665 5.72498 20.3665C5.19413 20.3665 4.68524 20.1556 4.30998 19.78C3.93442 19.4047 3.72351 18.8958 3.72351 18.365C3.72351 17.8342 3.93442 17.3253 4.30998 16.95L4.36998 16.89C4.84167 16.4078 4.97231 15.6871 4.69998 15.07C4.44093 14.4655 3.84762 14.0726 3.18998 14.07H2.99998C1.89541 14.07 0.999985 13.1746 0.999985 12.07C0.999985 10.9654 1.89541 10.07 2.99998 10.07H3.08998C3.76237 10.0577 4.36629 9.63775 4.60998 9.01C4.88231 8.39288 4.75167 7.6722 4.27998 7.19L4.21998 7.13C3.84442 6.75475 3.63351 6.24586 3.63351 5.715C3.63351 5.18415 3.84442 4.67526 4.21998 4.3C4.59524 3.92444 5.10413 3.71353 5.63498 3.71353C6.16584 3.71353 6.67472 3.92444 7.04998 4.3L7.10998 4.36C7.59218 4.83169 8.31286 4.96233 8.92998 4.69H8.99998C9.60449 4.43095 9.99731 3.83764 9.99998 3.18V3C9.99998 1.89543 10.8954 1 11.9999 1C13.1045 1 13.9999 1.89543 13.9999 3V3.09C14.0026 3.74764 14.3954 4.34095 14.9999 4.6C15.617 4.86233 16.3377 4.73169 16.8199 4.26L16.8799 4.2C17.2552 3.82444 17.7641 3.61353 18.2949 3.61353C18.8258 3.61353 19.3347 3.82444 19.7099 4.2C20.0855 4.57526 20.2964 5.08415 20.2964 5.615C20.2964 6.14586 20.0855 6.65475 19.7099 7.03L19.6499 7.09C19.1783 7.5722 19.0476 8.29288 19.3199 8.91V9C19.579 9.60449 20.1723 9.99731 20.8299 10H20.9999C22.1045 10 22.9999 10.8954 22.9999 12C22.9999 13.1046 22.1045 14 20.9999 14H20.9099C20.2522 14.0027 19.6489 14.3955 19.3899 15"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

// NEW ICONS START HERE

export function SinglePlayerIcon({ size = 24, color = "currentColor", className = "" }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="2" // Added default strokeWidth for consistency
      strokeLinecap="round" // Added for consistency
      strokeLinejoin="round" // Added for consistency
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="8" r="4" />
      <path d="M20 21C20 16.5817 16.4183 13 12 13C7.58172 13 4 16.5817 4 21" />
    </svg>
  );
}

export function MultiplayerIcon({ size = 24, color = "currentColor", className = "" }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="1.5" // Adjusted strokeWidth slightly for two figures
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Larger silhouette (slightly behind) */}
      <circle cx="14" cy="7" r="3" />
      <path d="M19 19C19 15.6863 16.8284 13 14 13C11.1716 13 9 15.6863 9 19" />

      {/* Smaller silhouette (slightly in front) */}
      <circle cx="8" cy="8" r="2.5" />
      <path d="M12.5 17C12.5 14.5147 10.4853 12.5 8 12.5C5.51472 12.5 3.5 14.5147 3.5 17" />
    </svg>
  );
}
